import {
  DEFAULT_VIEW_STATE_ID,
  LAST_ACTIVE_LOCAL_STORAGE_KEY,
} from '../constants'
import { scopeToInternalString } from '../scope'
import type { Scope } from '../types'

export const readLastActiveFromLocalStorage = (): Record<
  string,
  string | undefined
> => {
  return JSON.parse(localStorage.getItem(LAST_ACTIVE_LOCAL_STORAGE_KEY) ?? '{}')
}

export const writeLastActiveToLocalStorage = (
  lastActive: Record<string, string | undefined>,
) => {
  const initial: Record<string, string | undefined> = {}
  const json = JSON.stringify(
    Object.entries(lastActive)
      .filter(([, val]) => val !== undefined && val !== DEFAULT_VIEW_STATE_ID)
      .reduce((prev, cur) => {
        return {
          ...prev,
          [cur[0]]: cur[1],
        }
      }, initial),
  )
  localStorage.setItem(LAST_ACTIVE_LOCAL_STORAGE_KEY, json)
}

export const findLastActiveIdFromLocalStorage = (
  scope: Scope,
): string | undefined => {
  const key = scopeToInternalString(scope)
  const found = Object.entries(readLastActiveFromLocalStorage()).find(
    ([k]) => key === k,
  )
  return found ? found[1] : undefined
}

export const writeLastActiveIdToLocalStorage = (
  scope: Scope,
  lastActiveId: string | undefined,
) => {
  const key = scopeToInternalString(scope)
  const updated = {
    ...readLastActiveFromLocalStorage(),
    [key]: lastActiveId,
  }
  writeLastActiveToLocalStorage(updated)
}
